/* Progressive enhancement: native radio inputs enforce selection even without JavaScript. */
(() => {
  const init = (scope = document) => {
    const selectors = [];
    if (scope.matches?.('[data-kit-selector]')) selectors.push(scope);
    selectors.push(...(scope.querySelectorAll?.('[data-kit-selector]') || []));
    selectors.forEach((container) => {
      if (container.dataset.kitInitialized === 'true') return;
      container.dataset.kitInitialized = 'true';
      const groups = [...container.querySelectorAll('[data-kit-component]')];
      const status = container.querySelector('[data-kit-message]');
      const form = container.closest('form');
      const sync = () => {
        let allSelected = true;
        groups.forEach((group) => {
          const checked = group.querySelector('[data-kit-input]:checked');
          if (!checked) allSelected = false;
          group.querySelectorAll('.ptc-kit__size').forEach((label) => {
            label.classList.toggle('is-selected', Boolean(label.querySelector('input:checked')));
          });
          const selectedText = group.querySelector('[data-kit-selected]');
          if (selectedText) selectedText.textContent = checked?.value || 'Selecciona';
        });
        if (status) {
          status.classList.remove('is-error');
          status.textContent = allSelected ? 'Listo. Las tallas seleccionadas se guardarán en tu pedido.' : 'Selecciona todas las tallas antes de agregar el kit al carrito.';
        }
      };
      container.addEventListener('change', sync);
      form?.addEventListener('invalid', (event) => {
        if (event.target.matches?.('[data-kit-input]') && status) {
          status.textContent = 'Selecciona una talla para cada componente del kit.';
          status.classList.add('is-error');
        }
      }, true);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();